import styled from "styled-components";

const AvatarImg = styled.img`
  border-radius: 50%;
  margin-right: 1em;
  width: 15vh;
  height: 15vh;
  object-fit: cover;
`;

export default AvatarImg;
